import ReactOnRails from "react-on-rails";
import RootApp from "../../client/app/startup/RootApp";

ReactOnRails.register({ RootApp });
